export default function(x) {
  return +x;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-scale/src/number.js
// module id = 89
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12